import { Injectable } from '@angular/core';
import { MatDateFormats } from '@angular/material/core';

export type DateFormatType = 'DDMMYYYY' | 'MMDDYYYY';

@Injectable({
  providedIn: 'root'
})
export class DateFormatService {
  constructor() {}
  currentFormat: DateFormatType = 'DDMMYYYY';

  private readonly DATE_FORMAT_DMY: MatDateFormats = {
    parse: { dateInput: 'DD/MM/YYYY' },
    display: {
      dateInput: 'DD/MM/YYYY',
      monthYearLabel: 'MMM YYYY',
      dateA11yLabel: 'DD/MM/YYYY',
      monthYearA11yLabel: 'MMMM YYYY'
    }
  };

  private readonly DATE_FORMAT_MDY: MatDateFormats = {
    parse: { dateInput: 'MM/DD/YYYY' },
    display: {
      dateInput: 'MM/DD/YYYY',
      monthYearLabel: 'MMM YYYY',
      dateA11yLabel: 'MM/DD/YYYY',
      monthYearA11yLabel: 'MMMM YYYY'
    }
  };

  setFormat(format: DateFormatType) {
    this.currentFormat = format;
  }

  get formats(): MatDateFormats {
    return this.currentFormat === 'MMDDYYYY' ? this.DATE_FORMAT_MDY : this.DATE_FORMAT_DMY;
  }
}
